const CurrencyHelper = {
    formatPrice(value, locale = 'nl') {
        if (value === null || value === undefined) {
            return null;
        }
        const parsed = parseFloat(value);
        if (isNaN(parsed)) {
            return null;
        }
        return parsed.toLocaleString(locale, {
            style: 'currency',
            currency: 'EUR',
        });
    },
};

export default CurrencyHelper;
